import { TREE_URL } from "@/api/system/department"
import { 
  createTableActionItem, 
  createTableColumn, 
  createTableHeaderButton 
} from "@/component-create/utils/create-table-column"
import { Table } from "@/component-create/Table"
import { DEPARTMENT_STATUS } from "@/constant/system/code"
import { formatter } from "@/utils/common"

type Row = TColumnControls<'rowDelete' | 'rowEdit' | 'rowAdd'>
type Header = THeaderControls<'addFn' | 'searchFn'>

export function createTable(
  el: Element,
  row: Row,
  table: Header
) {
    
  const _table = new Table(
    el, 
    column(row), 
    headerButtons(table), 
    { border: true, rowKey: 'id' }, 
    TREE_URL,
    {
      responseConfig: {
        total: () => 0,
        data: (data: any) => data
      }
    }
  )

  return _table
}

export function column(rowHandler: Row) {
  const col: TableColumnProp[] = [
    createTableColumn('部门名称', 'departmentName', '480'),
    createTableColumn('部门编码', 'departmentCode', '200', 'center'),
    createTableColumn('顺序', 'sort', '60', 'center'),
    createTableColumn('状态', 'status', '60', 'center', { formatter: row => formatter(DEPARTMENT_STATUS, row.status) }),
    createTableColumn('备注', 'remark', undefined, undefined, { showOverflowTooltip: true }),
    createTableColumn('创建时间', 'createdAt', '150', 'center'),
    createTableColumn('操作', undefined, '200', 'center', {
      controller: [
        createTableActionItem('新增', 'Plus', rowHandler.rowAdd),
        createTableActionItem('编辑', 'Edit', rowHandler.rowEdit),
        createTableActionItem('删除', 'Delete', rowHandler.rowDelete),
      ]
    }),
  ]
  return col
}

/**
 * 表格头部按钮
 */
function headerButtons(table: Header) {
  return [
    createTableHeaderButton('刷新', 'primary', 'Search', table.searchFn),
    createTableHeaderButton('新增', 'primary', 'Plus', table.addFn),
  ]
} 